module.exports = __webpack_public_path__ + "img/no-image.f98b32ce.png";